import React from 'react';
import { Form } from 'react-bootstrap';

interface AccommodationInputNumberProps {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  HandleChange: (event: any) => void;
  InputId: string;
  InputName?: string;
  InputValue?: string | number;
  LabelText: string;
  IsRequired?: boolean;
  Disbled?: boolean;
}

const AccommodationInputNumber = ({
  HandleChange,
  InputId,
  InputName = null,
  InputValue = null,
  IsRequired = true,
  LabelText,
  Disbled,
}: AccommodationInputNumberProps) => {
  return (
    <Form.Group className="mb-24">
      <Form.Label className={IsRequired ? 'required' : ''} htmlFor={InputId}>
        {LabelText}
      </Form.Label>
      <Form.Control
        disabled={Disbled}
        type="number"
        id={InputId}
        required={IsRequired}
        value={InputValue}
        onChange={HandleChange}
        name={InputName !== null ? InputName : InputId}
      />
    </Form.Group>
  );
};

// AccommodationInputNumber.defaultProps = {
//   InputName: null,
//   InputValue: null,
//   IsRequired: true,
// };

export default AccommodationInputNumber;
export { AccommodationInputNumber };
export type { AccommodationInputNumberProps };
